module.exports = __webpack_public_path__ + "img/ms-team-3545.50a1f7b.jpg";